import isNil from './is-nil';
export default (function (value) {
  if (isNil(value)) return '';
  return value.toString();
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/to-string.js
// module id = 9
// module chunks = 0